import React from 'react';
import classNames from 'classnames';
import { IProvider } from 'src/types/provider';
import styles from './assets/incentive-form.module.scss';
interface Props {
    original: Partial<IProvider>;
    data: any;
    setData: any;
}

const PrlProviderActionsColumn: React.FunctionComponent<Props> = ({ original, data, setData }) => {
    const handleChange = (event: any) => {
        const idValue = data[`${original?.id}`];

        if (idValue?.action) {
            delete data[`${original?.id}`];
            setData({
                ...data,
            });
        } else {
            setData({
                ...data,
                [`${original?.id}`]: {
                    ...idValue,
                    action: !idValue?.action,
                },
            });
        }
    };
    const actionValue = data[`${original?.id}`]?.action;
    return (
        <div className={classNames(styles.actions)}>
            <input type="checkbox" checked={!!actionValue} onClick={(value) => handleChange(value)} />
        </div>
    );
};

export default PrlProviderActionsColumn;
